import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';

const TaskPriority = ({ createClicked , taskPriorities, defultPriority, useMargin }, ref) => {
	
	const lan = useLanguage();
	const [priority, setPriority] = useState(defultPriority);
	useImperativeHandle(ref, () => priority, [priority]);
	const handleChange = (event) => {
		setPriority(event.target.value);
	};
	useEffect(() => {
		if (defultPriority !== undefined) {
			setPriority(defultPriority);
		}
	}, [defultPriority]);
	const getDetaultNameOrNormal = (id, name) => {
		if (id === 1 || id === 2 || id === 3) {
			return lan['severity_' + id];
		} else {
			return name;
		}
	}
	const MenuProps = {
		PaperProps: {
		  style: {
			maxHeight: 48 * 4.5 + 8,
			width: 250,
		  },
		},
	  };
	return (
    <FormControl variant='outlined' fullWidth>
      <InputLabel id='priority-select-label'>{lan.priority}</InputLabel>
      <Select
        labelId='priority-select-label'
        id='priority-select'
        value={priority}
        onChange={handleChange}
        label={lan.priority}
        MenuProps={MenuProps}
        sx={{borderRadius: '12px !important'}}
      >
         {taskPriorities !== undefined ? taskPriorities.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {getDetaultNameOrNormal(id, name)}
          </MenuItem>
        )):null}
      </Select>
    </FormControl>
	);
};
export default forwardRef(TaskPriority);
